<template>
    <div style="width: 100%">
        <canvas id="chart-by-status"></canvas>
    </div>
</template>

<script>
import Chart from "chart.js";
import _service from "@/services/orderService";

export default {
    name: "PlanetChart",
    data() {
        return {
            ChartData: null,
            labelChart: [],
            valueChart: [],
        };
    },
    async mounted() {
        const data = await _service.getResumenByStatus();
        var datos = data.data;
        var object = function (key, text) {
            this.key = key;
            this.text = text;
        };

        var objArray = [];
        objArray[0] = new object("Activo");
        objArray[1] = new object("En proceso");
        objArray[2] = new object("Cancelada");
        objArray[3] = new object("Completada");

        var keys = objArray.map(function (o) {
            return o.key;
        });

        this.labelChart = keys; // ["Activo", "En proceso", "Cancelada", "Completada"];
        this.valueChart = [
            datos["ordersActives"],
            datos["ordersInProcess"],
            datos["ordersCancelled"],
            datos["ordersCompleted"],
        ];
        const ChartData = {
            type: "bar",
            data: {
                labels: this.labelChart,
                datasets: [
                    {
                        label: "Resumen de Ordenes por Estatus",
                        data: this.valueChart,
                        backgroundColor: "#3F69A6",
                        borderColor: "#3F69A6",
                        borderWidth: 3,
                    },
                ],
            },
            options: {
                responsive: true,
                lineTension: 1,
                scales: {
                    yAxes: [
                        {
                            ticks: {
                                beginAtZero: true,
                                padding: 25,
                            },
                        },
                    ],
                },
            },
        };

        this.ChartData = ChartData;

        const ctx = document.getElementById("chart-by-status");
        new Chart(ctx, this.ChartData);
    },
};
</script>
